import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicModalAbstractComponent } from '../../../classes/dynamic-modal-abstract-component';
import { DynamicModalLoaderService } from '../../../services/dynamic-modal-loader.service';

@Component({
  selector: 'gen-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DisclaimerModalComponent extends DynamicModalAbstractComponent implements OnInit {
  public content: string;
  public contentParams: string;

  constructor(modalLoaderService: DynamicModalLoaderService) {
    super(modalLoaderService);
  }

  onNext(payload): void {
    this.content = payload && payload['content'] || '';
    this.contentParams = payload && payload['params'] || '';
  }

  onError(error): void {
  }

  onComplete(): void {
  }


  ngOnInit() {
  }
}
